<template>
  <div :class="wrapperStyles">
    <div class="row typography sidebar__mobile-mode__holder">
      <h2 class="col-7">{{ title }}</h2>
      <div class="col-5 text-right">
        <button class="sidebar__mobile-mode map-control" @click="onMobileToggle">
          Show map
        </button>
      </div>
    </div>
    <slot name="notification"></slot>
    <slot name="header"></slot>
    <slot name="body"></slot>
    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    expanded: {
      type: Boolean
    },
    onMobileToggle: {
      type: Function
    }
  },

  computed: {
    wrapperStyles() {
      return {
        sidebar: true,
        "sidebar--expanded": this.expanded === true,
        "sidebar--collapsed": this.expanded === false,
        "pr-0": true,
        "pl-0": true,
        "pr-md-0": this.expanded === false,
        "col-12": true,
        "col-md-3": this.expanded === false,
        "col-lg-8": this.expanded === true,
        "col-xl-2": this.expanded === false
      };
    }
  }
};
</script>
